import {Component, Input, OnInit} from '@angular/core';
import {MatDialog} from '@angular/material';
import {SendCalculationDialogComponent} from '../../dialogs/send-calculation-dialog/send-calculation-dialog.component';
import {isNestBank} from '../../../../core/utils/utils';

@Component({
  selector: 'app-send-offer-banner',
  templateUrl: './send-offer-banner.component.html'
})
export class SendOfferBannerComponent implements OnInit {

  @Input() imageSrc: string;

  mailIconSrc: string;

  constructor(private dialog: MatDialog) { }

  ngOnInit() {
    this.initMailIcon();
  }

  mailOffer(): void {
    this.dialog.open(SendCalculationDialogComponent);
  }

  private initMailIcon(): void {
    this.mailIconSrc = isNestBank() ? './assets/images/icons/mail-black.svg' : './assets/images/icons/mail-white.svg';
  }

}
